import { Mail, Phone, MapPin } from "lucide-react";
import logoAsset from "@/assets/zenisoft-logo.png";

export function Footer() {
  return (
    <footer className="bg-[var(--brand-navy-deep)] text-white/80">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div>
          <div className="mb-4 inline-block rounded-lg bg-white p-2">
            <img src={logoAsset} alt="Zenisoft" className="h-10 md:h-12 w-auto" />
          </div>
          <p className="text-sm leading-relaxed">
            We build ERP systems that power African businesses — finance, inventory, HR, and operations in one platform.
          </p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/about" className="hover:text-white">About</a></li>
            <li><a href="/case-studies" className="hover:text-white">Case Studies</a></li>
            <li><a href="/contact" className="hover:text-white">Contact</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">Solutions</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/solutions" className="hover:text-white">ERP Solutions</a></li>
            <li><a href="/astra" className="hover:text-white">Astra ERP Platform</a></li>
            <li><a href="/astra-pos" className="hover:text-white">Astra POS</a></li>
            <li><a href="/industries" className="hover:text-white">Industries</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">Contact</h4>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4" /> Accra, Ghana</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4" /><span>business@zenisoft.com</span></li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4" /><span>+233 54 604 4269 | +233 55 434 3921</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6 text-xs flex flex-col sm:flex-row justify-between gap-2">
          <span>© 2026 Zenisoft Ghana. All rights reserved.</span>
          <span>Built for African enterprises.</span>
        </div>
      </div>
    </footer>
  );
}
